/**
 * Carrossel de categorias do cabeçalho — setas + fade em qualquer largura.
 */
(function () {
  const ROOT_SEL = '[data-andrade-categories-carousel]';
  const SCROLLER_SEL = '[data-andrade-categories-scroller]';

  const getScroller = (root) => root.querySelector(SCROLLER_SEL);

  const syncCarousel = (root) => {
    const scroller = getScroller(root);
    if (!scroller) return;

    const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    const scrollable = maxScroll > 4;
    const atStart = scroller.scrollLeft <= 2;
    const atEnd = scroller.scrollLeft >= maxScroll - 2;

    root.classList.toggle('is-scrollable', scrollable);
    root.classList.toggle('is-at-start', atStart);
    root.classList.toggle('is-at-end', atEnd);

    const prev = root.querySelector('[data-andrade-cat-prev]');
    const next = root.querySelector('[data-andrade-cat-next]');
    if (prev) prev.disabled = !scrollable || atStart;
    if (next) next.disabled = !scrollable || atEnd;
  };

  const bindCarousel = (root) => {
    if (root.dataset.andradeCarouselBound === '1') return;
    root.dataset.andradeCarouselBound = '1';

    const scroller = getScroller(root);
    if (!scroller) return;

    let scrollRaf = 0;
    const onScroll = () => {
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(() => {
        scrollRaf = 0;
        syncCarousel(root);
      });
    };

    scroller.addEventListener('scroll', onScroll, { passive: true });

    const step = () => Math.max(180, Math.round(scroller.clientWidth * 0.55));
    const prev = root.querySelector('[data-andrade-cat-prev]');
    const next = root.querySelector('[data-andrade-cat-next]');
    if (prev) {
      prev.addEventListener('click', () => {
        scroller.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', () => {
        scroller.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    onScroll();

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => syncCarousel(root));
      ro.observe(scroller);
      const list = scroller.querySelector('.header-categories-nav__list');
      if (list) ro.observe(list);
    }
  };

  const init = () => {
    document.querySelectorAll(ROOT_SEL).forEach(bindCarousel);
    document.querySelectorAll(ROOT_SEL).forEach(syncCarousel);
  };

  const schedule = () => {
    window.requestAnimationFrame(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  let resizeTimer;
  window.addEventListener(
    'resize',
    () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(schedule, 100);
    },
    { passive: true }
  );

  document.addEventListener('shopify:section:load', schedule);
})();
